export default __webpack_public_path__ + "static/media/planta-da-feira.88a8d6d0.png";